import PagerShort from "../assets/sounds/pager_short.wav";

export const NotificationSounds = {
  PagerShort,
};
